import React from 'react';
import Layout from '../components/Layout';
import ForgotPasswordCard from '../components/ForgotPasswordCard';

function ForgotPassword() {

  return (
    <Layout videoUrl="https://burakgundogan.net/videos/9129751-hd_1920_1080_25fps.mp4">
      <ForgotPasswordCard />
    </Layout>
  );
}

export default ForgotPassword;